import Vue from 'vue'

let vueInstance = null

export function initVue(config = {}) {
  vueInstance = new Vue(config)
  return vueInstance
}

export function getVueInstance() {
  if (vueInstance) return vueInstance
}
